import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"icon-check\"><path d=\"m5.525 11.657-4.95-4.95L1.99 5.293l3.537 3.534v.001L14.01.343l1.414 1.414-8.485 8.486-1.413 1.413z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol